/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Answer_PronunciationInputs */

const en_faq_answer_pronunciation = /** @type {(inputs: Faq_Answer_PronunciationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yep. If our audio ever mispronounces a word, just let us know and we'll fix it.`)
};

const es_faq_answer_pronunciation = /** @type {(inputs: Faq_Answer_PronunciationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Si nuestro audio pronuncia mal alguna palabra, avísanos y lo corregiremos.`)
};

/**
* | output |
* | --- |
* | "Yep. If our audio ever mispronounces a word, just let us know and we'll fix it." |
*
* @param {Faq_Answer_PronunciationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const faq_answer_pronunciation = /** @type {((inputs?: Faq_Answer_PronunciationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Answer_PronunciationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_faq_answer_pronunciation(inputs)
	return en_faq_answer_pronunciation(inputs)
});